// Module
var code = "<formly-transclude></formly-transclude> <div ng-if=\"options.data.Children.length\" class=\"formly row control-row repeater-border\"> <formly-form fields=\"options.data.Children\" form=\"form\" model=\"{}\"> </formly-form> </div> ";
// Exports
export default code;